import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { SectionHeading } from "./Section";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { ctaNote, images, offerIncludes, offerStack } from "../data/offer";
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-title" className="bg-navy px-4 py-14 text-white sm:px-6 md:py-20" data-id="element-199" data-mp="dg86whym803r">
      <div className="mx-auto max-w-5xl" data-id="element-200" data-mp="metlk20yuuz9">
        <SectionHeading id="offer-title" dark eyebrow="The special launch offer" title="Here's Everything You'll Receive Today" data-id="element-201" data-mp="mdsb9zrrycil" />

        <div className="mx-auto mt-10 max-w-2xl overflow-hidden rounded-3xl bg-white text-ink ring-4 ring-gold/60" data-id="element-202" data-mp="repsoa4yn2j1">
          <div className="bg-gold px-5 py-3 text-center text-sm font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-203" data-mp="wan5i6h0lqr2">
            The Facelift Blueprint™ Complete System
          </div>

          <div className="px-5 pb-8 pt-4 sm:px-8" data-id="element-204" data-mp="2y6grldbp2ju4">
            <img src={images.hero} alt="Facelift Blueprint™ complete system" className="mx-auto w-full max-w-md" data-id="element-205" data-mp="12ns6bhruuz3e" />

            <ul className="mt-2 divide-y divide-line border-y border-line" data-id="element-206" data-mp="xw0bgv1o277g">
              {offerStack.map(s => <li key={s.title} className="flex gap-4 py-4" data-id="element-207" data-mp="sxyqg4kojxtc">
                  <div className="flex-1" data-id="element-208" data-mp="owwt5tabpvu0">
                    <p className="font-bold leading-snug" data-id="element-209" data-mp="ou0to0ituz3g">{s.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-210" data-mp="1ll340xxu9kgq">{s.detail}</p>
                  </div>
                  <p className="shrink-0 text-sm text-muted" data-id="element-211" data-mp="1gnt76x84e6iv">
                    Ref. <s data-id="element-212" data-mp="1ckwoz7mhscfg">{s.value}</s>
                  </p>
                </li>)}
            </ul>

            <div className="mt-6 text-center" data-id="element-213" data-mp="17ljxg9koeh6j">
              <p className="text-sm font-semibold uppercase tracking-wider text-muted" data-id="element-214" data-mp="17oy0lk15yuf1">
                Total proposed reference value: <s className="text-rose" data-id="element-215" data-mp="3scavxfggnxsk">$294</s>
              </p>
              <p className="mt-3 text-sm font-bold uppercase tracking-[0.12em] text-navy" data-id="element-216" data-mp="3sex3vg79kfbb">Today, get complete digital access for just</p>
              <p className="mt-1 font-serif text-7xl font-bold leading-none text-cta sm:text-8xl" data-id="element-217" data-mp="2o82rbs3962g">
                $27<span className="ml-1 align-top font-sans text-xl font-bold text-ink" data-id="element-218" data-mp="3ktunu7o59we9">USD</span>
              </p>
              <p className="mt-3 text-[15px] font-semibold text-ink" data-id="element-219" data-mp="3otvagfleddwe">One-time payment. No subscription. No recurring fees.</p>
            </div>

            <p className="mt-6 text-xs font-bold uppercase tracking-[0.14em] text-gold-dark" data-id="element-220" data-mp="3b1f5h98xr5su">You'll receive:</p>
            <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-221" data-mp="315c2602cl14b">
              {offerIncludes.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug" data-id="element-222" data-mp="3645g1tljqu50">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-223" data-mp="3622eccb17ckg" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-224" data-mp="2x5tewxn20dyb">
              <CTAButton label="Get the Facelift Blueprint™ — $27" note={ctaNote} data-id="element-225" data-mp="2dhf55idelr4w" />
            </div>

            <Countdown data-id="element-226" data-mp="28jdlowc2fpsw" />
            <ScarcityBar data-id="element-227" data-mp="28k5k0ex1s1mv" />

            <div className="mt-4 flex gap-3 rounded-2xl bg-sand p-4" data-id="element-228" data-mp="28kyjcutofouz">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy" aria-hidden="true" data-id="element-229" data-mp="2mjepoknmndcl" />
              <p className="text-sm leading-relaxed text-ink" data-id="element-230" data-mp="2ifyrhjvwt4xs">
                <strong data-id="element-231" data-mp="2wgjdsq119iw1">Automatic currency conversion.</strong> The checkout will automatically display the price in your local
                currency, if available.
              </p>
            </div>

            <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-muted" data-id="element-232" data-mp="366cn1kdpdlx4">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-233" data-mp="316zqu90xz2hv" /> Secure checkout · Instant digital delivery
            </p>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-white/75" data-id="element-234" data-mp="3f7kd5f62fgg4">
          Instead of purchasing another disconnected educational resource, you'll have one organized system you can return to whenever
          you study facelift cases.
        </p>
      </div>
    </section>;
}